import { render, staticRenderFns } from "./HomeBannerUser.vue?vue&type=template&id=fd2ff102&scoped=true"
import script from "./HomeBannerUser.vue?vue&type=script&lang=js"
export * from "./HomeBannerUser.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerUser.vue?vue&type=style&index=0&id=fd2ff102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ff102",
  null
  
)

export default component.exports